import { createSlice } from '@reduxjs/toolkit'
import { STORE_HUB } from 'components/ui/utils/constant'

const stateSlice = createSlice({
    name: 'ticketList/state',
    initialState: {
        changeStatusConfirmation: false,
        deleteConfirmation: false,
        selectedTicket: '',
        viewTicket: false,
        dialogView: '',
        changeOperatorView: false,
        inboxSideBarExpand: true,
        inboxMobileSideBarExpand: false,
        showLinkingTicket: false,
        sortedColumn: () => { },
        viewMode: localStorage.getItem('ticketViewMode') || 'cards',
    },
    reducers: {
        toggleChangeStatusConfirmation: (state, action) => {
            state.changeStatusConfirmation = action.payload
        },
        toggleDeleteConfirmation: (state, action) => {
            state.deleteConfirmation = action.payload
        },
        toggleChangeOperator: (state, action) => {
            state.changeOperatorView = action.payload
        },
        toggleLinkTicket: (state, action) => {
            state.showLinkingTicket = action.payload
        },
        setSortedColumn: (state, action) => {
            state.sortedColumn = action.payload
        },
        setSelectedTicketSlice: (state, action) => {
            state.selectedTicket = action.payload
        },
        toggleTicketDialog: (state, action) => {
            state.viewTicket = action.payload
        },
        setDialogView: (state, action) => {
            state.dialogView = action.payload
        },
        setInboxSideBarExpand: (state, action) => {
            state.inboxSideBarExpand = action.payload
        },
        setInboxMobileSideBarExpand: (state, action) => {
            state.inboxMobileSideBarExpand = action.payload
        },
        openTicketForm: (state, action) => {
            state.dialogView =  STORE_HUB.ADD_TICKET
            state.viewTicket = true
        },
        setViewMode: (state, action) => {
            state.viewMode = action.payload
            localStorage.setItem('ticketViewMode', action.payload)
        },

        // Los cuatro primeros flags gatean modales directamente desde Redux, sin estado
        // local de React (ChangeOperatorDialog, TicketDeleteConfirmation,
        // TicketChangeStatusConfitmation, LinkTicketDialog). Antes el reload los volvía
        // a false gratis al recrear el store; ahora que alternar de vista solo remonta el
        // árbol, uno que quedó en true haría que la otra vista aparezca con un modal ya
        // abierto sin que el usuario haya tocado nada.
        //
        // `inboxMobileSideBarExpand` entra en la misma bolsa que los modales: es un panel
        // que se abre encima del contenido, no una preferencia. Lo que NO se toca a
        // propósito es `inboxSideBarExpand` y `viewMode`: eso es cómo el usuario dejó
        // acomodada la pantalla, y perderlo al cambiar de vista sería un retroceso.
        //
        // Tampoco se tocan `viewTicket`, `dialogView` ni `selectedTicket`: esos NO son de
        // esta pantalla. Gatean el `TicketDialog` que el layout monta global para toda la
        // app (`components/layout/index.js`), o sea el formulario de alta que se abre con
        // el "+" del header desde cualquier página. Limpiarlos acá cerraba ese formulario
        // a mitad de carga, sin pasar por su propia confirmación de "cambios sin guardar",
        // en cuanto este árbol volvía a montarse: al alternar de vista, o al entrar a
        // Tareas con el formulario abierto.
        resetTicketUiState: (state) => {
            state.changeStatusConfirmation = false
            state.deleteConfirmation = false
            state.changeOperatorView = false
            state.showLinkingTicket = false
            state.inboxMobileSideBarExpand = false
        },

    },
})

export const {
    toggleChangeStatusConfirmation,
    toggleDeleteConfirmation,
    toggleChangeOperator,
    toggleLinkTicket,
    setSortedColumn,
    toggleTicketDialog,
    setDialogView,
    setSelectedTicketSlice,
    setInboxSideBarExpand,
    setInboxMobileSideBarExpand,
    openTicketForm,
    setViewMode,
    resetTicketUiState

} = stateSlice.actions

export default stateSlice.reducer
